<script lang="ts" setup>
    import blokStyleClasses from '~/utils/blokStyleClasses';

    const props = defineProps<{ blok: GTripleRowStoryblok }>();

    const { hidden } = useBlokVisibility(props.blok);
    const { isDraftModeEnabled } = useDraftMode();

    const gridClasses = computed(() => {
        const { customMargin, customPadding, customGap, customTheme } = blokStyleClasses(props.blok);

        const widthClass = props.blok?.width === 'fullWidth' ? '--full-width' : '';
        const marginClass = props.blok?.margin !== 'default' ? customMargin : '';
        const paddingClass = customPadding;
        const gapClass = props.blok?.gap !== 'default' ? customGap : '';
        const themeRoundCornersClass = props.blok?.themeRoundCorners ? '--theme-round-corners' : '';
        const hasBg = props.blok?.theme !== 'default' ? '--has-bg' : '';
        const bgColorClass = props.blok?.theme !== 'default' ? customTheme : '';
        const revertMobileLayout = props.blok?.revertMobileLayout ? '--revert-mobile-layout' : '';

        return [
            widthClass,
            marginClass,
            paddingClass,
            gapClass,
            themeRoundCornersClass,
            hasBg,
            bgColorClass,
            revertMobileLayout
        ].filter(Boolean);
    });
</script>

<template>
    <div
        v-show="!hidden || isDraftModeEnabled"
        :id="props.blok?.anchorId"
        v-editable="props.blok"
        class="grid-wrapper triple-row"
        :class="gridClasses"
    >
        <StoryblokComponentWrapper
            v-for="(item, index) in props.blok?.content"
            :key="item._uid"
            :blok="item"
            :style="props.blok?.revertMobileLayout ? 'order: ' + index * -1 : ''"
        />
    </div>
</template>

<style scoped>
    @import '~/assets/scss/grid/grid.scss';
</style>
